import { LoaderFunction } from 'react-router-dom';
import { client } from '~/api/client';
import { queryData } from '~/api/data/request';
import { loadQuery } from '~/api/data/responses';
import {
  EmailThreadFieldsFragment,
  GetEmailThreadDocument,
  GetEmailThreadQuery,
  GetEmailThreadQueryVariables,
  GetEmailThreadsDocument,
  GetEmailThreadsQuery,
  GetEmailThreadsQueryVariables,
  MailboxAccountFieldsFragment,
  MailboxAccountsDocument,
  MailboxAccountsQuery,
  MailboxAccountsQueryVariables,
  MailboxProvider,
  MailboxProvidersDocument,
  MailboxProvidersQuery,
  MailboxProvidersQueryVariables
} from '~/api/graphql';

export const getEmailThreads = async () =>
  queryData<GetEmailThreadsQuery, GetEmailThreadsQueryVariables, EmailThreadFieldsFragment[]>(
    client,
    { query: GetEmailThreadsDocument },
    (data) => data?.emailThreads || []
  );

export const getEmailThread = async (id: string) =>
  queryData<GetEmailThreadQuery, GetEmailThreadQueryVariables, EmailThreadFieldsFragment>(
    client,
    { query: GetEmailThreadDocument, variables: { id: id } },
    (data) => data?.emailThread
  );

export const getMailboxAccounts = async () =>
  queryData<MailboxAccountsQuery, MailboxAccountsQueryVariables, MailboxAccountFieldsFragment[]>(
    client,
    { query: MailboxAccountsDocument },
    (data) => data?.mailboxAccounts
  );

export const getMailboxProviders = async () =>
  queryData<MailboxProvidersQuery, MailboxProvidersQueryVariables, MailboxProvider[]>(
    client,
    { query: MailboxProvidersDocument },
    (data) => data?.mailboxProviders
  );

export const loadEmailThreads: LoaderFunction = () =>
  loadQuery(getEmailThreads(), { suppressAuthErrors: true });

export const loadEmailThread: LoaderFunction = ({ params }) =>
  loadQuery(getEmailThread(params.id || ''));

export const loadMailboxAccounts: LoaderFunction = () => loadQuery(getMailboxAccounts());

export const loadMailboxProviders: LoaderFunction = () => loadQuery(getMailboxProviders());
